"use client";

import { ClerkProvider } from "@clerk/nextjs";
import { Toaster } from "sonner";

import { AuthCookieSync } from "@/frontend/components/providers/auth-cookie-sync";
import { QueryProvider } from "@/frontend/components/providers/query-provider";
import { ThemeProvider } from "@/frontend/components/providers/theme-provider";

export function RootProviders({ children }: { children: React.ReactNode }) {
  return (
    <ClerkProvider>
      <AuthCookieSync />
      <QueryProvider>
        <ThemeProvider
          attribute="class"
          defaultTheme="light"
          forcedTheme="light"
          enableSystem
        >
          <Toaster richColors position="bottom-center" />
          {children}
        </ThemeProvider>
      </QueryProvider>
    </ClerkProvider>
  );
}
